<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">选择入住老人</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <div style="padding-right: 10px;">
          <div style="float:right">
            <el-input size="mini" placeholder="请输入姓名" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
            <el-button size="mini" type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
          </div>
          <div style="clear:both;"></div>
        </div>

        <el-row style="margin-top:20px">
          <el-col :span="24">
            <el-table :data="elderlyInfo" ref="tableSelectElderly" style="width: 100%" border :height="300">
              <el-table-column label="姓名" prop="name" width="100"></el-table-column>
              <el-table-column label="手机号" prop="phone"></el-table-column>
              <el-table-column label="身份证号" prop="idCard"></el-table-column>
              <el-table-column label="地址" prop="homeAddress" ></el-table-column>
              <el-table-column fixed="right"  label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="primary" size="small" @click.native.prevent="handleSelect(scope.$index, scope.row)">选择</el-button>
                </template>
              </el-table-column>
            </el-table>

          </el-col>
        </el-row>

        <div class="page">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="pageSize"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'ElderlySelect',
  props:[],
  data() {
    return {

      name:'',

      loading: false,
      elderlyInfo:[],

      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      medicinerCode:'',
      institutionCode:'',

    }
  },

  components:{

  },
  methods: {
    init(medicinerCode,insCode){
      this.medicinerCode = medicinerCode;
      this.institutionCode = insCode;
      this.getElderly()
    },
    closeSelf() {
      this.$emit("closeSelectAdd");
      this.$emit("getList");
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getElderly();
    },

    getElderly(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Checkin/GovPage3",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          elderlyName:this.name,
        }
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.elderlyInfo=response.data.data.pageInfo.list;
              this.totalItems = response.data.data.pageInfo.total;

              this.$nextTick(()=>{
                this.$refs.tableSelectElderly.doLayout();
              });

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          })
    },

    handleSelect(index,row){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Mediciner/AddElderlyRel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          medicinerCode:this.medicinerCode,
          listElderlyCode:[row.elderlyCode],
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.$message.info("添加成功");

        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },

  }
}


</script>

